/* regalo-web.js v4 (19-10-2026, boton ELEGIR MI PERFUME en el carrito) - Decants Milano
   Reglas de los regalos en la web (el dueño las probo el 19-10):
   - Regalo de la OLA (handle tu-regalo-gratis, a 0): uno solo por pedido y nunca solo.
     v3: SIN pedir el telefono en la pagina ("esta feo"). Quien lo usa sin estar en la ola lo
     frena la base al entrar el pedido (aviso al grupo "NO va el regalo").
   - 3o GRATIS (handle tu-3er-perfume-gratis): 1 cada 2 perfumes pagados. v3: si no corresponde
     NO SE PUEDE AGREGAR al carrito (antes entraba y Shopify lo cobraba a precio normal).
   Como:
   1) Se intercepta /cart/add: si el que se agrega es un regalo que no corresponde, no llega a
      Shopify y el cliente ve el motivo.
   2) Si el carrito queda mal igual (saco perfumes despues), se APAGAN los botones de pagar.
   3) A /cart.js se le esconde el renglon del regalo de la ola para que kit-logica no lo cuente
      como perfume. Las cuentas de aca leen /cart.js?dmregalo=1, que no se toca. */
(function () {
  var OLA = 'tu-regalo-gratis';
  var KIT = 'tu-3er-perfume-gratis';
  var CART_PROPIO = '/cart.js?dmregalo=1';

  var fetchReal = window.fetch;
  if (!fetchReal || window.__dmRegaloFetch) return;
  window.__dmRegaloFetch = true;

  /* ---------- cuentas ---------- */
  function contar(c) {
    var ola = 0, kit = 0, eleg = 0;
    (c.items || []).forEach(function (i) {
      if (i.handle === OLA) ola += i.quantity;
      else if (i.handle === KIT) kit += i.quantity;
      else if ((i.product_title || '').indexOf('Combo') === -1) eleg += i.quantity;
    });
    return { ola: ola, kit: kit, eleg: eleg, permitidos: Math.floor(eleg / 2) };
  }
  function faltanPara(n) { return Math.max(1, (n.kit + 1) * 2 - n.eleg); }

  /* variant id -> handle de los dos productos regalo (se piden una vez) */
  var mapa = null;
  function mapaRegalos() {
    if (mapa) return mapa;
    mapa = Promise.all([OLA, KIT].map(function (h) {
      return fetchReal('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return { h: h, ids: p ? p.variants.map(function (v) { return v.id; }) : [] }; })
        .catch(function () { return { h: h, ids: [] }; });
    })).then(function (ls) {
      var m = {};
      ls.forEach(function (l) { l.ids.forEach(function (id) { m[id] = l.h; }); });
      return m;
    });
    return mapa;
  }

  function itemsDelAlta(init) {
    try {
      var b = init && init.body;
      if (!b) return [];
      if (typeof FormData !== 'undefined' && b instanceof FormData) {
        return [{ id: Number(b.get('id')), quantity: Number(b.get('quantity') || 1) }];
      }
      if (typeof b === 'string') {
        var o = JSON.parse(b);
        if (o.items) return o.items.map(function (i) { return { id: Number(i.id), quantity: Number(i.quantity || 1) }; });
        if (o.id) return [{ id: Number(o.id), quantity: Number(o.quantity || 1) }];
      }
    } catch (e) {}
    return [];
  }

  function rechazo(msg) {
    aviso(msg);
    return new Response(JSON.stringify({ status: 422, message: msg, description: msg }),
      { status: 422, headers: { 'Content-Type': 'application/json' } });
  }

  window.fetch = function (input, init) {
    var u = typeof input === 'string' ? input : ((input && input.url) || '');
    var self = this, args = arguments;

    /* 1) alta al carrito: se revisan los regalos ANTES de que lleguen a Shopify */
    if (/\/cart\/add/.test(u)) {
      var nuevos = itemsDelAlta(init);
      if (!nuevos.length) return fetchReal.apply(self, args);
      return mapaRegalos().then(function (m) {
        var olaNuevo = 0, kitNuevo = 0;
        nuevos.forEach(function (i) { if (m[i.id] === OLA) olaNuevo += i.quantity; else if (m[i.id] === KIT) kitNuevo += i.quantity; });
        if (!olaNuevo && !kitNuevo) return fetchReal.apply(self, args);
        return fetchReal(CART_PROPIO, { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
          var n = contar(c);
          if (olaNuevo && n.ola + olaNuevo > 1) return rechazo('Es un solo regalo por pedido 🎁 Ya tenés uno en el carrito.');
          if (kitNuevo && n.kit + kitNuevo > n.permitidos) {
            var f = faltanPara(n);
            return rechazo('🎁 Sumá ' + f + ' perfume' + (f > 1 ? 's' : '') + ' más y elegí tu regalo GRATIS.');
          }
          return fetchReal.apply(self, args);
        }).catch(function () { return fetchReal.apply(self, args); });
      });
    }

    var p = fetchReal.apply(self, args);
    /* 3) kit-logica no ve el regalo de la ola */
    if (!/\/cart\.js(\?|$)/.test(u) || u.indexOf('dmregalo=1') !== -1) return p;
    return p.then(function (r) {
      return r.clone().json().then(function (j) {
        if (!j || !j.items) return r;
        var quedan = j.items.filter(function (i) { return i.handle !== OLA; });
        if (quedan.length === j.items.length) return r;
        j.items = quedan;
        j.item_count = quedan.reduce(function (s, i) { return s + i.quantity; }, 0);
        return new Response(JSON.stringify(j), { status: r.status, headers: { 'Content-Type': 'application/json' } });
      }).catch(function () { return r; });
    });
  };

  function el(tag, css, html) { var e = document.createElement(tag); if (css) e.style.cssText = css; if (html) e.innerHTML = html; return e; }

  function aviso(msg) {
    var v = document.getElementById('dm-regalo-toast');
    if (!v) {
      v = el('div', 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:99999;max-width:92vw;' +
        'background:#111;color:#fff;padding:14px 18px;border-radius:12px;font-size:15px;line-height:1.35;' +
        'box-shadow:0 6px 24px rgba(0,0,0,.25);text-align:center');
      v.id = 'dm-regalo-toast';
      document.body.appendChild(v);
    }
    v.textContent = msg;
    v.style.display = 'block';
    clearTimeout(v._t);
    v._t = setTimeout(function () { v.style.display = 'none'; }, 6000);
  }

  /* ---------- pagina del regalo de la ola: sin "comprar ya" ni cantidad ---------- */
  function ajustarPagina() {
    if (location.pathname.indexOf('/products/' + OLA) === -1) return;
    document.head.appendChild(el('style', '',
      '.shopify-payment-button,product-form .shopify-payment-button,.product-form__quantity,.quantity{display:none!important}' +
      'variant-selects input.disabled+label,variant-selects input[disabled]+label{display:none!important}'));
  }

  /* ---------- 2) no se paga con los regalos mal ---------- */
  var SEL_PAGAR = '[name="checkout"], #checkout, #CartDrawer-Checkout, #bp-pagar, button[form="cart"][type="submit"]';
  var motivo = null;

  function leerMotivo(c) {
    var n = contar(c);
    if ((n.ola > 0 || n.kit > 0) && n.eleg === 0) return '🎁 Tu regalo va con un pedido: sumá el perfume que quieras y después pagás 😉';
    if (n.ola > 1) return 'Es un solo regalo por pedido 🎁 Dejá uno en el carrito para seguir.';
    if (n.kit > n.permitidos) {
      var f = faltanPara({ kit: n.permitidos, eleg: n.eleg });
      return '🎁 Tu 3º gratis va con 2 perfumes: sumá ' + f + ' más o sacá el regalo.';
    }
    return null;
  }

  function pintarBotones() {
    document.querySelectorAll(SEL_PAGAR).forEach(function (b) {
      if (motivo) {
        if (!b.disabled) { b.disabled = true; b.setAttribute('data-dm-apagado', '1'); }
        b.title = motivo;
        b.style.opacity = '.45';
      } else if (b.getAttribute('data-dm-apagado') === '1') {
        b.disabled = false; b.removeAttribute('data-dm-apagado'); b.title = ''; b.style.opacity = '';
      }
    });
    var nota = document.getElementById('dm-regalo-nota');
    var ancla = document.querySelector('#CartDrawer-Checkout') || document.querySelector('#main-cart-footer [name="checkout"]');
    if (motivo && ancla) {
      if (!nota) {
        nota = el('div', 'margin:8px 0 0;font-size:13px;font-weight:700;color:#b45309;text-align:center');
        nota.id = 'dm-regalo-nota';
      }
      /* solo si cambia: escribir igual dispararia el MutationObserver del carrito en bucle */
      if (nota.getAttribute('data-m') !== motivo) {
        nota.setAttribute('data-m', motivo);
        nota.textContent = motivo;
        /* v4: "los clientes no leen" (dueño 19-10): si falta el perfume, un BOTON que lleva a elegirlo */
        if (motivo.indexOf('sumá el perfume') !== -1 || motivo.indexOf('Sumá') === 0 || motivo.indexOf('sumá ') !== -1) {
          var a = el('a', 'display:block;margin:8px auto 0;background:#0a8f3c;color:#fff;text-decoration:none;font-weight:900;font-size:15px;border-radius:10px;padding:13px 10px;text-align:center');
          a.href = '/collections/catalogo-completo';
          a.textContent = 'ELEGIR MI PERFUME →';
          nota.appendChild(a);
        }
      }
      if (nota.parentNode !== ancla.parentNode) ancla.parentNode.insertBefore(nota, ancla.nextSibling);
    } else if (nota) { nota.remove(); }
  }

  var tCheck = null;
  function revisar() {
    clearTimeout(tCheck);
    tCheck = setTimeout(function () {
      fetchReal(CART_PROPIO, { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) { motivo = leerMotivo(c); pintarBotones(); })
        .catch(function () {});
    }, 250);
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest(SEL_PAGAR);
    if (!b || !motivo) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    aviso(motivo);
  }, true);
  document.addEventListener('submit', function (e) {
    if (!motivo) return;
    var sub = e.submitter;
    var f = e.target;
    var va = (sub && sub.name === 'checkout') || (f && f.querySelector && f.querySelector('[name="checkout"]') && (!sub || sub.name === 'checkout'));
    if (!va) return;
    e.preventDefault(); e.stopPropagation();
    aviso(motivo);
  }, true);

  function vigilar() {
    revisar();
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, revisar); } catch (e) {}
    }
    /* el carrito se re-pinta: se observan SOLO sus contenedores (nunca document.body) */
    ['cart-drawer', '#main-cart-footer', '#main-cart-items', 'cart-items'].forEach(function (s) {
      var n = document.querySelector(s);
      if (n) new MutationObserver(function (lista) {
        var ajenos = lista.some(function (m) { return !(m.target && m.target.id === 'dm-regalo-nota') &&
          !Array.prototype.some.call(m.addedNodes || [], function (x) { return x.id === 'dm-regalo-nota'; }) &&
          !Array.prototype.some.call(m.removedNodes || [], function (x) { return x.id === 'dm-regalo-nota'; }); });
        if (ajenos) { pintarBotones(); revisar(); }
      }).observe(n, { childList: true, subtree: true });
    });
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('[name="add"], .cart-remove-button, cart-remove-button, .quantity__button, #cart-icon-bubble, .header__icon--cart');
      if (t) setTimeout(revisar, 800);
    });
  }

  function arrancar() { ajustarPagina(); vigilar(); mapaRegalos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
})();
